var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavaigateArrowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#9339DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.28898 13.8234C7.1137 13.7074 7.00972 13.5445 7.00065 13.3716C6.99157 13.1987 7.07817 13.0304 7.24079 12.9049L10.8955 10.0083L7.28095 7.11174C6.92984 6.85047 6.92984 6.43102 7.28095 6.16975C7.64554 5.93037 8.20343 5.94599 8.54203 6.20508L12.759 9.53735C12.9146 9.66074 13.0006 9.82269 13 9.99068C13.0002 10.1569 12.914 10.3169 12.759 10.4381L8.54203 13.7881C8.37552 13.9192 8.14384 13.9957 7.89944 14C7.67272 14.0002 7.45443 13.937 7.28898 13.8234Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavaigateArrowIcon);
export default __webpack_public_path__ + "static/media/navaigateArrowIcon.f8fb3036ddadfa75e62e4629f6c4f396.svg";
export { ForwardRef as ReactComponent };